import { PatternLibraryAreaRoutes } from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { SquaresIcon } from '@moia-dev/pace-icons'

export const PatternLibraryAreaNavigationIcon = SquaresIcon

export const PatternLibraryAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={PatternLibraryAreaRoutes.route}
      Icon={SquaresIcon}
    />
  )
}
